import * as angular from "angular";
import {DataHubService} from "../modules/DataHubModule";
import {IComponentController} from "angular";
import {DisposeBag} from "../modules/DisposeBag";
import {UserFullDto} from "../model/UserFullDto";

class UserSelectController implements IComponentController {
    records: UserFullDto[] = [];
    model: any;
    onSelect: Function;
    required: string;
    placeholder: string;
    showAll: Boolean;
    private disposeBag = new DisposeBag();

    constructor(private $dataHub: DataHubService, private $scope) {
        $dataHub.bindAllUser(() => this.records, this.disposeBag);
        $dataHub.onConnected(this.reload, this.disposeBag);
    }

    reload = () => {
        this.$dataHub.userSubscribeAndQuery().then(ret => this.records = ret);
    };

    $onInit(): void {
    }

    $onDestroy() {
        this.disposeBag.finalize();
    }
}

export default angular.module('component.userSelect', [])
    .component('userSelect', {
        template: require('./UserSelect.html'),
        controller: UserSelectController,
        bindings: {
            model: '=',
            onSelect: '&',
            required: '=',
            placeholder: '@',
            showAll: '=',
            allowClear: '='
        }
    }).name;
